module.exports = __webpack_public_path__ + "static/life_sciences-2e00fc5e9e79b4b8cb5bde9620115bf7.jpg";